<div class="wrapper">
  <app-dashboard>
    <div class="page">
      <div class="top-section">
        <div class="info-section">
          <div class="row">
            <div class="sub-info">
              <h1>Name</h1>
              <p class="sub-data">{{ this.singleWebhook.name }}</p>
            </div>
            <div class="sub-info">
              <h1>User ID</h1>
              <!-- <p>{{this.userId}}</p> -->
              <div class="sub-data">
                <app-copy-text-single-line
                  [text]="this.userId"
                ></app-copy-text-single-line>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sub-info">
              <h1>Webhook URL</h1>
              <p class="sub-data">{{ this.singleWebhook.webhookUrl }}</p>
            </div>
            <div class="sub-info">
              <h1>Sender URL</h1>
              <div class="sub-data">
                <app-copy-text-single-line
                  [text]="this.singleWebhook.senderUrl"
                ></app-copy-text-single-line>
              </div>
            </div>
          </div>
          <div class="row">
            <div *ngIf="this.singleWebhook.resend == true" class="sub-info">
              <h1>Resend Duration</h1>
              <p class="sub-data">
                {{ this.singleWebhook.resendDuration }} seconds
              </p>
            </div>
            <div *ngIf="this.singleWebhook.acceptableError.length > 0" class="sub-info">
              <h1>Acceptable Error(s)</h1>
              <p class="sub-data">{{ this.singleWebhook.acceptableError }}</p>
            </div>
          </div>
        </div>
        <div class="button-section">
          <app-button-fill
            [action]="updateWebhook"
            buttonText="Update Configuration"
          ></app-button-fill>
        </div>
      </div>
      <div class="second-section">
        <app-filter
          [data]="this.data"
          (filterChanged)="onFilterChanged($event)"
        ></app-filter>
        <div class="table">
          <app-request-table [processLoading]="fetchingData" [data]="requests" [view]="singleRequest"></app-request-table>
          <!-- parent.component.html -->
          <!-- <app-table
            [action]="requestDetails"
            [headers]="tableHeaders"
            [data]="tableData"
          ></app-table> -->
          <app-pagination *ngIf="!this.fetchingData && this.totalList > 0"
            [totalItems]="this.totalList" [(pageSize)]="this.limit"
            [(currentPage)]="this.page" (pageSizeChange)="this.refreshRequests()"
            (currentPageChange)="this.getRequests()"></app-pagination>
        </div>
      </div>
    </div>
  </app-dashboard>
</div>

<app-modal
[title]="this.singleWebhook.name"
[dateCreated]="this.singleWebhook.createdAt"
[dateUpdated]="this.singleWebhook.updatedAt"
  [isOpen]="isModalOpen"
  (closeModalEvent)="closeModal()"
>
  <!-- Dynamic content goes here -->
  <p-toast></p-toast>
  <div class="form-container">
    <div class="sub-form full-width">
      <div class="input-holder half-width">
        <div class="form-holder full-width">
          <app-input
            (dataEvent)="onUpdatedName($event)"
            [disabled]="true"
            [inputData]="this.formModal.name"
            label="Name"
          ></app-input>
        </div>

        <div class="form-holder half-width">
          <app-dropdown
            label="Webhook Type"
            [options]="typeOptions"
            [selectedValue]="this.formModal.type"
            (selectionChanged)="onUpdatedType($event)"
          ></app-dropdown>
        </div>

        <div
          *ngIf="this.formModal.type == 'Receiving'"
          class="form-holder half-width"
        >
          <app-input
            (dataEvent)="onUpdatedUrl($event)"
            [inputData]="this.formModal.webhookUrl"
            label="Webhook URL"
          ></app-input>
        </div>

        <div class="form-holder">
          <app-dropdown
            label="Resend Webhook"
            [options]="resendOptions"
            [selectedValue]="this.formModal.resend"
            (selectionChanged)="onUpdatedResend($event)"
          ></app-dropdown>
        </div>

        <div *ngIf="this.formModal.resend == 'true'" class="form-holder">
          <app-dropdown
            label="Resend Duration"
            [options]="timeOptions"
            [selectedValue]="this.duration"
            (selectionChanged)="onUpdatedResendDuration($event)"
          ></app-dropdown>
        </div>

        <!-- <div class="form-holder"><app-multi-select-checkbox [options]="acceptableErrors" [selectedValues]=this.formModal.acceptableError (selectionChanged)="onUpdatedErrors($event)"></app-multi-select-checkbox></div> -->
        <div class="form-holder full-width">
          <app-input
            (dataEvent)="onUpdatedError($event)"
            [inputData]="this.formModal.acceptableError"
            label="Acceptable Error(s)"
            placeholder="400,404,500"
          ></app-input>
        </div>
      </div>
    </div>
  </div>
  <div class="button">
    <app-button-fill
      [processLoading]="isLoading"
      [action]="patchWebhook"
      buttonText="Update Configurations"
    ></app-button-fill>
  </div>
  <!-- <div class="button"><app-button-outline [action]="closeModal" buttonText="Close"></app-button-outline></div> -->
</app-modal>

<app-modal
  [title]="modalTitle2"
  [isOpen]="isModalOpen2"
  (closeModalEvent)="closeModal2()"
>
  <!-- <span>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim eaque nisi excepturi dolores alias sapiente exercitationem provident, asperiores quia cupiditate soluta ratione facere ipsam sint accusantium, modi ut esse. Illum, vero fugiat ducimus voluptates animi fuga ea aliquam fugit facilis exercitationem est sunt corporis commodi natus mollitia nisi, nemo, quisquam accusamus. Obcaecati, illo facere molestiae repellendus consectetur voluptatum sunt animi rem consequatur error aperiam ad quasi fugiat odit doloremque, itaque ratione praesentium, dolorem aliquam ut debitis. Est placeat pariatur rerum, assumenda totam unde, alias, reiciendis possimus repudiandae quibusdam doloribus velit iusto? Aperiam deserunt nisi ab consequatur, veritatis autem excepturi ratione repellendus mollitia at modi sequi. Necessitatibus officia, ullam incidunt soluta provident facere, deleniti laudantium dolorem similique beatae iusto asperiores. Dolores maiores exercitationem laboriosam fugiat sit animi voluptatum tenetur aliquid, perspiciatis recusandae mollitia architecto autem repudiandae. Cupiditate veniam voluptatem ipsam eligendi, exercitationem repellendus tenetur quos quia, ducimus consectetur nisi voluptatum laborum, dolore quaerat recusandae consequatur! Sequi natus, laudantium architecto amet cupiditate aperiam maxime sit quis adipisci recusandae? Ex, illum? Autem cum modi possimus aliquid accusantium aliquam dignissimos doloremque fugiat accusamus nam, rerum ex commodi quo aut alias facilis magni fuga architecto nemo. Tempora perspiciatis natus quam consectetur assumenda quia tempore ea?</span> -->
  <div *ngIf="this.requests && this.individualRequest" class="table-grid">
    <span class="key">Webhook ID</span>
    <span class="value">{{ this.individualRequest._id }}</span>

    <span class="key">Name</span>
    <span class="value">{{ this.individualRequest.name }}</span>

    <span class="key">Created At</span>
    <span class="value">{{ this.individualRequest.createdAt }}</span>

    <span class="key">Method</span>
    <span class="value">{{ this.individualRequest.method }}</span>

    <span class="key">URL</span>
    <span class="value">{{ this.individualRequest.url }}</span>

    <span class="key"> Status</span>
    <span class="value">{{ this.individualRequest.status }}</span>

    <span class="key">Response Status</span>
    <span class="value">{{ this.individualRequest.responseStatus }}</span>

    <span class="key">Trials</span>
    <span class="value">{{ this.individualRequest.trials }}</span>

    <span class="key">Required Trials</span>
    <span class="value">{{ this.individualRequest.requiredTrials }}</span>

    <span class="key">Request Body</span>
    <div class="value box" *ngIf="individualRequest?.body">
      <div *ngFor="let key of getObjectKeys(individualRequest.body)">
        {{ key }}: {{ individualRequest.body[key] | json }}
      </div>
    </div>

    <span class="key">Response Body</span>
    <div class="value box" *ngIf="individualRequest?.response && individualRequest.response.length > 0">
        <div *ngFor="let key of getObjectKeys(individualRequest.response[0]?.body)">
          {{ key }}: {{ individualRequest.response[0]?.body[key] | json }}
        </div>
      </div>
  </div>
  <!-- <div class="detail-section"> -->
  <!-- <div class="sub-detail">
        <h1>Webhook ID</h1>
        <p>{{this.individualRequest._id}}</p>
       </div>
       <div class="sub-detail">
        <h1>Name</h1>
        <p>{{this.webhookConfig.name}}</p>
       </div>
       <div class="sub-detail">
        <h1>Created At</h1>
        <p>{{this.webhookConfig.createdAt}}</p>
       </div>
       <div class="sub-detail">
        <h1>Method</h1>
        <p>{{this.individualRequest.method}}</p>
       </div>
       <div class="sub-detail">
        <h1>URL</h1>
        <p>{{this.individualRequest.url}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response Status</h1>
        <p>{{this.individualRequest.responseStatus}}</p>
       </div>
       <div class="sub-detail">
        <h1>Trials</h1>
        <p>{{this.individualRequest.trials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Required Trials</h1>
        <p>{{this.individualRequest.requiredTrials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response</h1>
        <div *ngIf="individualRequest.response && individualRequest.response.length > 0" [innerHTML]="individualRequest.response[0].body"></div>
       </div> -->

  <!-- </div> -->

  <!-- <div class="button"><app-button-outline [action]="closeModal" buttonText="Close"></app-button-outline></div> -->
</app-modal>
